// src/layouts/MasterLayout.js
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const MasterLayout = ({ children }) => {
  return (
    <Container className="main-container">
      <Row>
        <Col md={3} className="sidebar-left">
          {/* Left Sidebar */}
        </Col>
        <Col md={6} className="main-content">
          {/* Main Content */}
          {children}
        </Col>
        <Col md={3} className="sidebar-right">
          {/* Right Sidebar */}
        </Col>
      </Row>
    </Container>
  );
};

export default MasterLayout;
